import {Component, Input} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Favorite} from '@models/favorite';
import {AdUserFavorite} from '@models/ad';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';
import {TrackingService} from '@services/tracking.service';
import {PhoneComponent} from '@components/popup/phone/phone.component';

// Annonce publiée par un partenaire : remplace contact et liens par « Je suis intéressé par le projet ».
// Sans mobile sur le compte -> popup de saisie, puis POST app/ad/{ai_id}/lead. Ensuite, selon
// publisher_contact : coordonnées (ad.owner_*) en 'direct', message de rappel sinon.
@Component({
    selector: 'app-partner-interest',
    templateUrl: './partner-interest.component.html',
    styleUrls: ['./partner-interest.component.scss']
})
export class PartnerInterestComponent {

    @Input() favorite: Favorite;
    interested = false;
    loading = false;

    constructor(
        private dialog: MatDialog,
        private adService: AdService,
        private userService: UserService,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private trackingService: TrackingService) {
    }

    get publisher(): AdUserFavorite {
        return this.favorite && this.favorite.ad ? this.favorite.ad.user_favorite : null;
    }

    get isDirect(): boolean {
        return !!this.publisher && this.publisher.publisher_contact === 'direct';
    }

    // Le créateur de l'annonce (user_favorite.favorite_id = ce favori) ne peut pas se déclarer intéressé
    get isOwner(): boolean {
        return !!this.publisher && !!this.favorite.id && '' + this.publisher.favorite_id === '' + this.favorite.id;
    }

    // Onglet Leads de ce favori
    get leadsTabLink(): any[] {
        const listId = this.favorite.favorite_list && this.favorite.favorite_list.id ? this.favorite.favorite_list.id : 'all';
        return ['/app/favorites', listId, this.favorite.id, 'leads'];
    }

    // Lien du bien fourni par le publieur : uniquement ad.user_favorite.url (rien n'est attendu dans ad.urls
    // pour ces annonces custom)
    get adUrl(): string {
        return this.publisher && this.publisher.url ? this.publisher.url : '';
    }

    get isActive(): boolean {
        return !!this.favorite && !!this.favorite.ad && this.favorite.ad.is_active !== false;
    }

    interest(): void {
        this.trackingService.click('partner_lead', this.favorite.ad.ai_id);
        if (this.userService.getMobile(this.authenticationService.currentUser)) {
            this.sendLead();
            return;
        }
        const dialogRef = this.dialog.open(PhoneComponent, {width: '480px'});
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.sendLead();
            }
        });
    }

    private sendLead(): void {
        this.loading = true;
        this.adService.leadAd(this.favorite.ad.ai_id).subscribe(() => {
            this.loading = false;
            this.interested = true;
        }, error => {
            this.loading = false;
            this.alertService.error(typeof error === 'string' ? error : 'La demande a échoué, veuillez réessayer.');
        });
    }
}
